export default "__VITE_ASSET__PLX2pMtr__"